import { ProductService } from "~/services/product.service";

export default defineNuxtRouteMiddleware(async (to) => {
  const isValidProductPath = /^\d+$/.test(to.params.id);

  if (!isValidProductPath) return;

  const productId = to.params.id;

  // Replace this with your actual API or product lookup logic
  const product = await new ProductService().getProductByCode(productId);

  if (!product || !product.code) {
    return abortNavigation({
      statusCode: 404,
      message: "Product not found in redirect",
    });
  }

  // Redirect to the real product slug URL
  return navigateTo(`/${product.slug}/p${product.code}`, { redirectCode: 301 });
});
